export default __webpack_public_path__ + "static/media/CloseModalX.270122f6.svg";